import {issueHovercardPath} from '@github-ui/paths'
import {type SafeHTMLString, SafeHTMLBox} from '@github-ui/safe-html'
import {Link, Text} from '@primer/react'
import {LABELS} from '../..'
import {TEST_IDS} from '../../constants'
import {graphql} from 'relay-runtime'
import type {StickyHeaderTitle$key} from './__generated__/StickyHeaderTitle.graphql'
import {useFragment} from 'react-relay'

const StickyHeaderTitleFragment = graphql`
  fragment StickyHeaderTitle on Issue {
    titleHTML
    number
    url
    repository {
      name
      owner {
        login
      }
    }
  }
`

export type StickyHeaderTitleProps = {
  headerTitleData: StickyHeaderTitle$key
}

export function StickyHeaderTitle({headerTitleData}: StickyHeaderTitleProps) {
  const {titleHTML, number, url, repository} = useFragment(StickyHeaderTitleFragment, headerTitleData)

  return (
    <>
      <Link
        href={url}
        target="_blank"
        data-hovercard-url={issueHovercardPath({
          owner: repository.owner.login,
          repo: repository.name,
          issueNumber: number,
        })}
        sx={{color: 'fg.default', fontWeight: 'bold', display: 'inline'}}
      >
        <SafeHTMLBox
          as="bdi"
          sx={{
            wordBreak: 'break-word',
            mr: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          className="markdown-title"
          html={titleHTML as SafeHTMLString}
          data-testid={TEST_IDS.issueTitle}
        />
      </Link>
      <Text
        sx={{
          color: 'fg.muted',
        }}
      >
        {LABELS.issueNumber(number)}
      </Text>
    </>
  )
}

try{ StickyHeaderTitle.displayName ||= 'StickyHeaderTitle' } catch {}